import { render } from "./EnbButton.vue?vue&type=template&id=48e6d4ea&scoped=true"
import script from "./EnbButton.vue?vue&type=script&lang=js"
export * from "./EnbButton.vue?vue&type=script&lang=js"

import "./EnbButton.vue?vue&type=style&index=0&id=48e6d4ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e6d4ea"]])

export default __exports__